export const GridArray = function (minX, maxX, minY, maxY) {
    this.minX = minX || false;
    this.maxX = maxX || false;
    this.minY = minY || false;
    this.maxY = maxY || false;
    this.limited = this.minX || this.maxX || this.minY || this.maxY;

    this.mainArray = [];

    this.maxIndexX = false;
    this.minIndexX = false;
    this.maxIndexY = false;
    this.minIndexY = false;
}

GridArray.prototype.clear = function () {
    this.mainArray = [];
};

GridArray.prototype.set = function (x, y, value) {
    if (x.constructor === Array) {
        value = y;
        y = x[1];
        x = x[0];
    }

    if (this.limited && !this.inLimit(x, y)) {
        throw 'Out of limit!';
    }

    if (!this.mainArray[x]) {
        this.mainArray[x] = [];
    }

    this.mainArray[x][y] = value;

    this.setHelperValues(x, y);

    return value;
}

GridArray.prototype.get = function (x, y) {
    if (x.constructor === Array) {
        y = x[1];
        x = x[0];
    }

    if (this.limited && !this.inLimit(x, y)) {
        throw 'Out of limit!';
    }

    if (this.mainArray[x]) {
        if (this.mainArray[x][y]) {
            return this.mainArray[x][y];
        } else {
            return null;
        }
    } else {
        return null;
    }
}

GridArray.prototype.inLimit = function (x, y) {
    if (this.minX !== false && x < this.minX) return false;
    if (this.maxX !== false && x > this.maxX) return false;
    if (this.minY !== false && y < this.minY) return false;
    if (this.maxY !== false && y > this.maxY) return false;
    return true;
}

GridArray.prototype.setHelperValues = function (x, y) {
    if (this.maxIndexX === false) {
        this.maxIndexX = x;
        this.minIndexX = x;
        this.lengthX = 1;
        this.maxIndexY = y;
        this.minIndexY = y;
        this.lengthY = 1;
    } else {
        this.minIndexX = x < this.minIndexX ? x : this.minIndexX;
        this.maxIndexX = x > this.maxIndexX ? x : this.maxIndexX;
        this.minIndexY = y < this.minIndexY ? y : this.minIndexY;
        this.maxIndexY = y > this.maxIndexY ? y : this.maxIndexY;
    }
};

GridArray.prototype.filter = function(callback) {
    const result = [];
    this.mainArray.forEach((row) => {
        row.forEach((value) => {
            if (value && callback(value)) {
                result.push(value);
            }
        });
    });
    return result;
};

export default GridArray;